import React from 'react'

import { ZariContext } from '_zari/context'

import { Table } from '_zari/core'

import { EstadosOSE } from 'constants/index'

import { CrudContactosModal } from 'sharedComponents/modals'

import { DownloadAxiosFile } from 'utils'

import * as FacturacionHistorialService from 'services/facturacionHistorial.service'

const OpcionesDropdownCell = ({ row, repetirConsultaDocumentos }) => {
  const __zariContext = React.useContext(ZariContext)

  const [mostrarCrudContactosModal, setMostrarCrudContactosModal] = React.useState(false)

  const clickDescargarXmlPrevio = React.useCallback(() => {
    FacturacionHistorialService.descargarXmlPrevioxId(row._id)
      .then(({ data, headers }) => {
        DownloadAxiosFile.downloadAsBlob(data, headers)
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }, [__zariContext, row])

  const clickRecuperarCdr = React.useCallback(() => {
    FacturacionHistorialService.actualizarCdrxId(row._id)
      .then(() => {
        __zariContext.snack('success', 'Cdr actualizado !')
        repetirConsultaDocumentos()
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }, [__zariContext, row, repetirConsultaDocumentos])

  const clickEnviarCorreo = React.useCallback(() => {
    __zariContext.loader.open('Enviando correo')
    FacturacionHistorialService.enviarCorreoXmlxId(row._id)
      .then(() => {
        __zariContext.snack('success', 'Correo enviado!')
        repetirConsultaDocumentos()
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
      .finally(() => {
        __zariContext.loader.close()
      })
  }, [__zariContext, row, repetirConsultaDocumentos])

  const clickEnviarCorreoConCdr = React.useCallback(() => {
    __zariContext.loader.open('Enviando correo')
    FacturacionHistorialService.enviarCorreoXmlCdrxId(row._id)
      .then(() => {
        __zariContext.snack('success', 'Correo enviado!')
        repetirConsultaDocumentos()
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
      .finally(() => {
        __zariContext.loader.close()
      })
  }, [__zariContext, row, repetirConsultaDocumentos])

  const clickDescargarCdr = React.useCallback(() => {
    FacturacionHistorialService.descargarCdrxId(row._id)
      .then(({ data, headers }) => {
        DownloadAxiosFile.downloadAsBlob(data, headers)
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }, [__zariContext, row])

  const clickConsultaSunat = React.useCallback(() => {
    FacturacionHistorialService.consultaSunatxId(row._id)
      .then(({ data }) => {
        __zariContext.snack('info', `${data.codigo} - ${data.mensaje}`)
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }, [__zariContext, row])

  return (
    <>
      <Table.Cell>
        <Table.Dropdown>
          {({ handleClose }) => [
            <Table.Dropdown.Item key='verificar-contactos' handleClose={handleClose} onClick={() => setMostrarCrudContactosModal(true)}>
              Verificar Contactos
            </Table.Dropdown.Item>,
            ...(row.estadoOSE === EstadosOSE.PROCESADO
              ? [
                  <Table.Dropdown.Item key='enviar-correo' handleClose={handleClose} onClick={clickEnviarCorreo}>
                    Enviar Correo
                  </Table.Dropdown.Item>,
                  <Table.Dropdown.Item key='enviar-correo-cdr' handleClose={handleClose} onClick={clickEnviarCorreoConCdr}>
                    Enviar Correo con Cdr
                  </Table.Dropdown.Item>,
                  <Table.Dropdown.Item key='descargar-cdr' handleClose={handleClose} onClick={clickDescargarCdr}>
                    Descargar Cdr
                  </Table.Dropdown.Item>,
                  <Table.Dropdown.Item key='consulta-sunat' handleClose={handleClose} onClick={clickConsultaSunat}>
                    Consulta SUNAT
                  </Table.Dropdown.Item>
                ]
              : []),
            ...(row.estadoOSE === EstadosOSE.PROCESADO_SINCDR
              ? [
                  <Table.Dropdown.Item key='recuperar-cdr' handleClose={handleClose} onClick={clickRecuperarCdr}>
                    Recuperar CDR
                  </Table.Dropdown.Item>
                ]
              : []),
            <Table.Dropdown.Item key='descargar-xml-previo' handleClose={handleClose} onClick={clickDescargarXmlPrevio}>
              Descargar Xml Previo
            </Table.Dropdown.Item>
          ]}
        </Table.Dropdown>
      </Table.Cell>

      {mostrarCrudContactosModal && (
        <CrudContactosModal show={mostrarCrudContactosModal} handleClose={() => setMostrarCrudContactosModal(false)} idSocio={row._idSocio} />
      )}
    </>
  )
}

export default React.memo(OpcionesDropdownCell)
